import parseGeoRaster from 'georaster';

class ParcelData{

    
    static getJSONFilesFromFolder = async () =>{
       
        try{
            let files = await fetch('/files.json')
                .then(response => response.json())
                .then(files => {return files})
            return files
        } catch(e){
            console.error('geojson error',e)
        }
        
    }

    static getTIFFilesFromFolder = async () =>{
        try{
            let files = await fetch('/tif.json')
                .then(response => response.json())
                .then(files => {return files})
            return files
        } catch(e){
            console.error('tiff error',e)
        }
    }

    static getAllParcels = async () =>{

        let files = await this.getJSONFilesFromFolder();
        let parcels = [];
        let settings = {
            parcelNames:[], 
            phenoPhases:[], 
            actuators:[], 
            hypotheses:["risque"],
            hypothesesVariations:["appliedDose"],
            mapTypes:["rawMap","interpolatedMap"]
        };
        for(let file of files){
            try{
                let geojson = await fetch(file)
                    .then(function(response) {
                        return response.json()
                    })
                // name from "name" field inside geojson file
                const nameSplit = geojson.name.split("_")
                
                let parcel = {
                    parcelName: nameSplit[1],
                    phenoPhase: nameSplit[0],
                    hypothesis: "risque",
                    geojson: geojson,
                    stat:{
                        height: 0,
                    }, 
                    tiff:{}
                }
                parcels.push(parcel)

                if (!settings.parcelNames.includes(nameSplit[1])) settings.parcelNames.push(nameSplit[1]) 
                if (!settings.phenoPhases.includes(nameSplit[0])) settings.phenoPhases.push(nameSplit[0]) 

                if(file === files[0]) { 
                    const properties = Object.keys(geojson.features[0].properties)
                    settings.caracs = properties
                }
                    
            } catch(e){
                console.error('geojson error',file, e)
            }
        }
        
        let tiffiles = await this.getTIFFilesFromFolder();
        for (let tiffile of tiffiles) {
            try {
                // name from tif file name
                // remove "data/" before split name
                const nameSplit = tiffile.split("/")[1].split("_")
                // get carac from file name
                const carac = nameSplit[2].split(".")[0]
                let tif = await fetch(tiffile)
                    .then(response => response.arrayBuffer() )
                    .then(parseGeoRaster)
                    .then(function(georaster) {
                        return georaster;
                });
                parcels.map(p => {
                    if (p.parcelName === nameSplit[1]
                        && p.phenoPhase === nameSplit[0]
                    ) {
                        p.tiff[carac] = tif
                    }
                    return p
                })
            } catch(e){
                console.error('tif error',tiffile, e)
            }
            
        }
        
        return {parcels, settings}
        
    }
}
export default ParcelData;
